import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import './js/axiosSetup';
import initSessionWatcher from './js/sessionWatcher';
import App from './js/App';
import * as serviceWorkerRegistration from './js/serviceWorkerRegistration';
import reportWebVitals from './js/reportWebVitals';
import Swal from 'sweetalert2';
import { installBrowserProtection } from './js/browserProtection';

installBrowserProtection();

if (typeof window !== 'undefined' && !window._swalAlertOverride) {
  window._swalAlertOverride = true;
  const nativeAlert = window.alert.bind(window);
  window.alert = function(message) {
    try {
      Swal.fire({
        text: message || '',
        icon: 'info',
        confirmButtonText: 'OK',
        customClass: { popup: 'swal-popup-custom' }
      });
    } catch (error) {
      nativeAlert(message);
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Normalize runtime API base if provided as a comma-separated list (some deployments inject multiple)
try {
  if (typeof window !== 'undefined' && window.__API_BASE__) {
    const raw = (window.__API_BASE__ || '').toString();
    const parts = raw.split(',').map(s => s.trim()).filter(Boolean);
    if (parts.length > 1) {
      // Prefer first entry and strip trailing slashes for consistency
      // eslint-disable-next-line no-console
      console.warn('window.__API_BASE__ contains multiple values, using the first:', parts);
    }
    window.__API_BASE__ = (parts[0] || '').replace(/\/+$/, '');
  }
} catch (e) {}

// Initialize session watcher (ping + storage events)
try { initSessionWatcher(); } catch (e) {}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
